export const SHOW_ALL_FILTERABLE_GALLERY_ITEMS_EVENT = 'wac:filterable-gallery:show-all-items';

export interface ShowAllFilterableGalleryItemsDetail {
	readonly query: string;
}

export const dispatchShowAllFilterableGalleryItems = (query: string) => {
	if (typeof window === 'undefined') return;

	window.dispatchEvent(
		new CustomEvent<ShowAllFilterableGalleryItemsDetail>(SHOW_ALL_FILTERABLE_GALLERY_ITEMS_EVENT, {
			detail: { query: query.trim() },
		}),
	);
};

export const subscribeToShowAllFilterableGalleryItems = (
	onShowAllItems: (detail: ShowAllFilterableGalleryItemsDetail) => void,
) => {
	if (typeof window === 'undefined') return () => undefined;

	const handleShowAllItems = (event: Event) => {
		onShowAllItems((event as CustomEvent<ShowAllFilterableGalleryItemsDetail>).detail);
	};

	window.addEventListener(SHOW_ALL_FILTERABLE_GALLERY_ITEMS_EVENT, handleShowAllItems);

	return () =>
		window.removeEventListener(SHOW_ALL_FILTERABLE_GALLERY_ITEMS_EVENT, handleShowAllItems);
};
